import { getSectors } from '@constants/common';
import { SECTOR } from '@constants/actions';
import createAction from './actionCreator';

export const initSectors = () => {
  return async function (dispatch: any) {
    const sectors = getSectors();
    dispatch(createAction(SECTOR.LIST, { sectors }));
  };
};
